export default __webpack_public_path__ + "static/media/title_cardboard.f72ea3be.jpg";